<template>
  <div
    id="top"
    class="w-100 space-for-navbar mb-3"
  >
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Invest</title>
          <g id="Splashes">
            <g id="Invest">
              <image
                width="6800"
                height="3818"
                transform="translate(0.14 0.19) scale(0.15)"
                :xlink:href="require('../assets/purchased_pics/shutterstock_590870102-16x9ratio.jpg')"
              />
              <g id="InvestLabel">
                <text
                  class="bmg-splashes-15"
                  transform="translate(690.56 391.95)"
                >I<tspan
                  class="bmg-splashes-3"
                  x="12.08"
                  y="0"
                >n</tspan><tspan
                  class="bmg-splashes-16"
                  x="38.76"
                  y="0"
                >v</tspan><tspan
                  x="59.84"
                  y="0"
                >esti</tspan><tspan
                  class="bmg-splashes-27"
                  x="130.56"
                  y="0"
                >n</tspan><tspan
                  class="bmg-splashes-21"
                  x="157.72"
                  y="0"
                >g</tspan></text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(638.13 421.54)"
                ><tspan class="bmg-splashes-28">T</tspan><tspan
                  x="12.97"
                  y="0"
                >o Imp</tspan><tspan
                  class="bmg-splashes-14"
                  x="86.22"
                  y="0"
                >r</tspan><tspan
                  class="bmg-splashes-7"
                  x="95.92"
                  y="0"
                >ov</tspan><tspan
                  x="124.4"
                  y="0"
                >e O</tspan><tspan
                  class="bmg-splashes-10"
                  x="167.02"
                  y="0"
                >r</tspan><tspan
                  x="177.42"
                  y="0"
                >t</tspan><tspan
                  class="bmg-splashes-6"
                  x="187.57"
                  y="0"
                >h</tspan><tspan
                  x="204.55"
                  y="0"
                >opedic</tspan><tspan
                  x="27.6"
                  y="30"
                >H</tspan><tspan
                  class="bmg-splashes-7"
                  x="47.92"
                  y="30"
                >e</tspan><tspan
                  x="62.65"
                  y="30"
                >ali</tspan><tspan
                  class="bmg-splashes-6"
                  x="90.85"
                  y="30"
                >n</tspan><tspan
                  class="bmg-splashes-11"
                  x="107.82"
                  y="30"
                >g Ou</tspan><tspan
                  class="bmg-splashes-24"
                  x="169.32"
                  y="30"
                >t</tspan><tspan
                  class="bmg-splashes-18"
                  x="179"
                  y="30"
                >c</tspan><tspan
                  x="192.85"
                  y="30"
                >o</tspan><tspan
                  class="bmg-splashes-6"
                  x="208.52"
                  y="30"
                >m</tspan><tspan
                  x="235.1"
                  y="30"
                >es</tspan><tspan
                  x="57.79"
                  y="60"
                >a</tspan><tspan
                  class="bmg-splashes-6"
                  x="72.54"
                  y="60"
                >n</tspan><tspan
                  x="89.51"
                  y="60"
                >d Build ROI</tspan></text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="">
      <div class="centered-on-page">
        <InvestProgressBar
          class="w-100"
          goal="1300000"
          raised="466294"
          raised-investors="10"
          processing="55000"
          processing-investors="1"
          :days-remaining="numDaysRemaining"
          duration-in-days="270"
        />
      </div>
    </div>
    <section
      id="invest"
      class="container-fluid rounded p-3 bg-dark z-depth-3 w-90 border"
    >
      <div class="row">
        <div class="col-lg-6 centered-on-page">
          <img
            class="img-fluid"
            style=""
            src="../assets/business_pics/shutterstock-166045121-labeled.jpg"
          >
        </div>
        <div class="col-lg-6 centered-on-page">
          <div class="card bg-white text-dark text-center p-3">
            <div class="h1">
              Seed Round - $1.3M
            </div>
            <div class="h2">
              Simple Agreement for Future Equity (SAFE) Securities
            </div>
            <div class="centered-on-page">
              <div class="h3 w-xs-80 w-lg-60">
                <hr class="my-3 bg-dark">
                <strong>Per SEC Section 506(c)</strong><br>
                Valuation to be Determined Following Completion<br>of Phase A Research and Development Underway
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 centered-on-page">
          <div class="text-dark bg-white text-center border p-3 m4">
            <div class="h1">
              <strong>Use of Proceeds:</strong> Hypothesis testing in live horses and sheep,
              proving sustained compression and fracture stability is feasible. and move
              preclinical products forward in development. To measure healing quality and
              rate vs currant standard of care; quantify risk mitigation
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="container mt-4 text-left grey-text h3 border p-3">
            <em class="font-weight-bold">Clinically Significant Scientific Research and Product Development</em>
            <span class="">
              of continuous compression devices, to promote better and faster fracture healing.
              There is no doubt that continuous compression is needed, nor is there any doubt
              that current devices lack the ability to provide it. If our research and development
              successfully achieves team expectations, BMG anticipates being the first to provide internal
              fixation hardware sustaining interfragmentary strain below 2%, compression and
              stability for full early weight bearing and exercise, and primary healing. Physician
              and partner interest is very high. Expected path to product launch is 1 year to FDA/ISO 510k
              approval, and 2 to 3 yrs to de novo 510k or PMA approval.
            </span>
          </div>
        </div>
      </div>
      <section
        id="invest-docs"
        class="my-3 container-fluid rounded p-3 bg-white w-95 border"
      >
        <div class="centered-on-page ">
          <div class="w-90">
            <div class="row">
              <div class="col-lg-4 col-xl-5 text-dark h1 centered-on-page">
                <span class="text-right">
                  Investment<br>Documents<br>Downloads
                </span>
              </div>
              <div class="col-lg-1">
                <div class="bg-dark w-100 h-5 w-lg-10 h-lg-100">
&nbsp;
                </div>
              </div>
              <div class="col-lg-7 col-xl-6 h4 text-dark">
                <div class="my-2">
                  <a
                    class="text-dark"
                    href="../BMG Executive Summary Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Executive Summary</a>
                </div>
                <div class="mb-2">
                  <a
                    class="text-dark"
                    href="../BMG Financial Introductory Pitch Deck Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Investor Pitch Deck</a>
                </div>
                <div class="mb-2">
                  <a
                    class="text-dark"
                    href="../BMG Operating Agreement Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Operating Agreement</a>
                </div>
                <div class="mb-2">
                  <a
                    class="text-dark"
                    href="../BMG Private Placement Memorandum Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Private Placement Memorandum (PPM)</a>
                </div>
                <div class="mb-2">
                  <a
                    class="text-dark"
                    href="../BMG Technical Overview Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Technical Overview</a>
                </div>
                <div class="">
                  <a
                    class="text-dark"
                    href="../BMG SAFE Investment Contract Rev[-].pdf"
                    target="_blank"
                  ><font-awesome-icon
                    icon="file-pdf"
                    size=""
                    class=""
                  /> Simple Agreement for Future Equity (SAFE)</a>
                </div>
              </div>
            </div>
            <div class="h2 text-center">
              <router-link
                :to="{ name: 'Contact', params: { section: 'top' }}"
                class="nav-link"
              >
                Contact BMG directly for any questions and to inquire about investing.
              </router-link>
            </div>
          </div>
        </div>
      </section>
    </section>

    <!-- New Gold Standard -->
    <section class="section z-depth-5 rounded m-5">
      <div class="centered-on-page w-100 bg-dark rounded">
        <!-- Section heading -->
        <h2 class="h2 text-white font-weight-bold text-center my-5 w-50">
          Expected to Become
          <div class="h1 my-2 text-gold font-weight-bold">
            The New Gold Standard
          </div>
          In Orthopaedic Trauma Care
        </h2>
      </div>

      <!-- Grid row -->
      <div class="row h3">
        <!-- Grid column -->
        <div class="col-lg-4 align-items-center d-flex">
          <img
            class=""
            style=""
            src="../assets/purchased_pics/rawpixel-id-646437-transparent-rotated.png"
            alt="Gold Standard"
          >
        </div>
        <div class="col-lg-8 p-3">
          <div class="row mb-3">
            <div class="col-1">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <div class="col-xl-10 col-md-11 col-10">
              <h5 class="h2 mb-3 text-primary">
                Competitors: almost all internal fixation hardware companies:
              </h5>
              <p class="dark-grey-text">
                Stryker, DePuy-Synthes, Arthrex, Wright Medical, Acumed, Merit Medical, and others.
              </p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-1">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <div class="col-xl-10 col-md-11 col-10">
              <h5 class="h2 mb-3 text-primary">
                Patenting: Bridging Medical Hardware is patented and patent pending with novel configurations:
              </h5>
              <p class="dark-grey-text">
                <ul class="">
                  <li>
                    No known competitive technology in the orthopedic hardware market
                  </li>
                  <li>
                    Expected to improve standard of care across a broad range of orthopedics
                  </li>
                  <li>
                    Can reduce medical costs and pain (medication, surgeries, practitioners, hardware)
                  </li>
                  <li>
                    Patenting worldwide rights to all bone, muscle, ligament and tendon repair
                  </li>
                  <li>
                    One Patent issued, multiple applications patent pending
                  </li>
                </ul>
              </p>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-1">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <div class="col-xl-10 col-md-11 col-10">
              <h5 class="h2 mb-3 text-primary">
                Market Pull: Expectations are that Orthopedic,
                podiatric and maxillofacial surgeons, veterinarians, hospital purchasing agents,
              </h5>
              <p class="dark-grey-text mb-0">
                insurers, and other key healthcare decision makers are anticipated to
                demand BMG technology as soon as published research, technical conference
                presentations and sales people establish performance, training and availability.
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <font-awesome-icon
                icon="share"
                size="2x"
                class="text-primary"
              />
            </div>
            <div class="col-xl-10 col-md-11 col-10">
              <h5 class="h2 mb-3 text-primary">
                Net Medical Cost Reduction: is anticipated almost equal
                to cost of the hardware.
              </h5>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END New Gold Standard -->
    <!-- Competition -->
    <div class="centered-on-page">
      <section class="section z-depth-5 p-3 mb-5 mx-3 bg-dark w-80 centered-on-page">
        <!-- Section heading -->
        <div class="text-dark card my-2 p-3 bg-white">
          <div class="row">
            <div class="col-md-4 centered-on-page">
              <h1 class="h1-responsive font-weight-bold">
                Competition
              </h1>
            </div>
            <div class="col-md-1 centered-on-page">
              <div class="bg-dark w-100 h-5 w-md-10 h-md-100">
&nbsp;
              </div>
            </div>
            <div class="col-md-7 text-left w-100">
              <h4 class="h4 font-weight-bold">
                <ul>
                  <li>All existing Internal Fixation Hardware</li>
                  <li>Fails to Sustain Primary Bone Healing</li>
                  <li>While enabling High Early weight Bearing and Exercise</li>
                </ul>
              </h4>
            </div>
          </div>
        </div>
      </section>
    </div>

    <section class="p-3 mb-5 mx-3 bg-white">
      <div class="centered-on-page mt-3">
        <div class="row w-60">
          <div class="col-lg-6">
            <div class="card card-cascade wider">
              <!-- Card image -->
              <div class="view view-cascade overlay">
                <img
                  class="card-img-top"
                  src="../assets/bio_pics/DrDorr.png"
                  alt="Dr Dorr"
                >
              </div>
              <!-- Card content -->
              <div class="card-body card-body-cascade text-center">
                <!-- Quote -->
                <h4 class="text-primary p-0 m-0">
                  <font-awesome-icon
                    icon="quote-left"
                    size="1x"
                    class="text-primary"
                  />
                  No screw device is currently available to surgeons which sustains applied compression as well as fixation...
                  <font-awesome-icon
                    icon="quote-right"
                    size="1x"
                    class="text-primary"
                  />
                </h4>
                <!-- Name -->
                <h3 class="card-title text-right">
                  <strong>- Dr. Lawrence D. Dorr</strong>
                </h3>
                <!-- Short Bio -->
                <p class="card-text">
                  Noted Authority, Orthopedic Surgeon, Inventor, BMG Board of Advisors,
                  Director, Dorr Institute for Arthritis Research and Education, Keck Hospital,
                  Keck Hospital at University of Southern California - Past President of the
                  Hip Society, Knee Society and American Assoc. of Hip and Knee Surgeons
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="card card-cascade wider">
              <!-- Card image -->
              <div class="view view-cascade overlay">
                <img
                  class="card-img-top"
                  src="../assets/bio_pics/Toth.jpg"
                  alt="Dr Toth"
                >
              </div>
              <!-- Card content -->
              <div class="card-body card-body-cascade text-center">
                <!-- Quote -->
                <h4 class="text-primary p-0 m-0">
                  <font-awesome-icon
                    icon="quote-left"
                    size="1x"
                    class="text-primary"
                  />
                  ...the original intent of open reduction and rigid internal fixation, primary bone healing is expected to be realized using the BMG system in a substantially greater number of fractures...
                  <font-awesome-icon
                    icon="quote-right"
                    size="1x"
                    class="text-primary"
                  />
                </h4>
                <!-- Name -->
                <h3 class="card-title text-right">
                  <strong>- Dr. Ferenc Toth</strong>
                </h3>
                <!-- Short Bio -->
                <p class="card-text">
                  Bone Growth expert, DVM, PhD, DACVS-LA, Assistant Professor, Department of
                  Veterinary Population Medicine, a BMG Primary Investigator, University of Minnesota
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- END Competition -->
    <!-- Market Size & Growth -->
    <section
      id="MarketSizeAndGrowth"
      class="section rounded mb-3 p-4 bg-dark text-white"
    >
      <!-- Section Header -->
      <div class="container rounded w-100 mt-2 p-3 bg-white text-dark">
        <div class="row">
          <div class="h1 col-md-3 text-right centered-on-page">
            Market Size<br>and Growth
          </div>
          <div class="col-md-2 centered-on-page">
            <div class="w-10 h-100 bg-dark">
&nbsp;
            </div>
          </div>
          <div class="col-md">
            <div class="h3 text-left">
              $7.6 B Total Addressable World Market
            </div>
            <div class="h4 text-primary">
              for Applicable Procedures
            </div>
            <div class="h5">
              <ul>
                <li>Identified by Orthopedic Surgeons</li>
                <li>Data extracted by Optum</li>
                <li>from Outpatient Standard Analytical File</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <!-- END Section Header -->
      <!-- Market Graph -->
      <div class="row my-3">
        <div class="col-lg-6 py-3 py-lg-0">
          <div class="rounded bg-dark p-3 h-100 centered-on-page">
            <img
              src="../assets/business_pics/MarketSizePieChart.png"
              width="100%"
            >
            <!-- <canvas id="marketChart" height="100" width="100"></canvas> -->
          </div>
        </div>
        <div class="col-lg-6 centered-on-page">
          <ul class="list-unstyled px-5 pl-0">
            <li>
              <span class="h2">Animal – Veterinary Trauma Device</span>
              <ul class="h4">
                <li>
                  <em class="">$0.6 Billion</em>
                  <ul>
                    <li>
                      Success is likely to justify more surgeries
                      <ul>
                        <li>Enabling veterinary market growth</li>
                        <li>No longer euthanize as the humane option</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <span class="h2">Human – Trauma &amp; Joint Devices</span>
              <ul class="h4">
                <li>
                  <em class="">6.9 Million</em>
                  <ul>
                    <li>Annual Applicable Trauma Procedures</li>
                    <li>8% Growth / Year</li>
                  </ul>
                </li>
                <li>
                  <em class="">$64 Billion</em>
                  <ul>
                    <li>Paid for trauma procedures annually</li>
                  </ul>
                </li>
                <li>
                  <em class="">$6.4 Billion</em>
                  <ul>
                    <li>Annual capturable trauma device mkt</li>
                    <li>
                      Plus $5 Billion in reduced industry cost
                      <ul>
                        <li>Reduce US Defense Limited Duty 0.6M Days/yr</li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <em class="">$0.6 Billion</em>
                  <ul>
                    <li>Joint replacement device enhancement</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- END Market Graph -->
    </section>
    <!-- END Market Size & Growth -->
    <!-- Timeline -->
    <section class="">
      <div class="container-fluid m-2 w-100 centered-on-page">
        <img
          class="img-fluid w-90"
          src="../assets/business_pics/Timeline.png"
        >
      </div>
    </section>
    <!-- END Timeline -->
    <!-- Product Line Progress -->
    <div class="container-fluid w-100 my-3">
      <img
        class="img-fluid w-100"
        src="../assets/business_pics/ProductLineProgress.jpg"
      >
    </div>
    <!-- END Product Line Progress -->
    <!-- Commercialization -->
    <section class="section rounded bg-dark m-3 p-3">
      <div class="row">
        <div class="col-lg-5 centered-on-page">
          <div class="">
            <div class="h1 text-secondary text-right">
              Projected Commercialization
            </div>
            <div class="h4 text-white text-right">
              of Bridging Medical<br>Screw, Plate &amp;Suture Technology
            </div>
          </div>
        </div>
        <div class="col-lg-7 centered-on-page">
          <!-- <img class="" src="../assets/business_pics/Commercialization.png" width="100%"> -->
          <table class="text-white">
            <tr class="border text-center">
              <th
                colspan="6"
                class="font-weight-bold h3"
              >
                Plan for Grants &amp; Investments in $M
              </th>
            </tr>
            <tr class="border text-center font-weight-bold">
              <th class="border h5">
                Round
              </th>
              <th class="border h5">
                Year
              </th>
              <th class="border h5">
                Screws
              </th>
              <th class="border h5">
                Plates
              </th>
              <th class="border h5">
                Sutures
              </th>
              <th class="border h5">
                Total
              </th>
            </tr>
            <tr class="font-weight-bold">
              <th class="text-center">
                <em>Seed</em>
              </th>
              <td class="text-center">
                <em>1</em>
              </td>
              <td class="text-right">
                <em>$ 0.8</em>
              </td>
              <td class="text-right">
                <em>$ 0.4</em>
              </td>
              <td class="text-right">
                <em>$ 0.1</em>
              </td>
              <td class="text-right">
                <em>$ 1.3</em>
              </td>
            </tr>
            <tr>
              <th class="text-center">
                A
              </th>
              <td class="text-center">
                2
              </td>
              <td class="text-right">
                $ 2.1
              </td>
              <td class="text-right">
                $ 1.1
              </td>
              <td class="text-right">
                $ 3.1
              </td>
              <td class="text-right">
                $ 6.3
              </td>
            </tr>
            <tr>
              <th class="text-center">
                B*
              </th>
              <td class="text-center">
                3
              </td>
              <td class="text-right">
                $ 15.0
              </td>
              <td class="text-right">
                $ 5.0
              </td>
              <td class="text-right">
                $ 8.0
              </td>
              <td class="text-right">
                $ 28.0
              </td>
            </tr>
            <tr>
              <th class="text-center">
                C*
              </th>
              <td class="text-center">
                4
              </td>
              <td class="text-right">
                $ 60.0
              </td>
              <td class="text-right">
                $ 20.0
              </td>
              <td class="text-right">
                $ 40.0
              </td>
              <td class="text-right">
                $ 120.0
              </td>
            </tr>
            <tr>
              <th
                colspan="6"
                class="text-center"
              >
                * Plan is for rounds B &amp; C, from
                year 3 on to be Self Funded, from Retained
                Earnings by Veterinary Product, Market
                Rights and HUman Market Product Sales
              </th>
            </tr>
          </table>
        </div>
      </div>
    </section>
    <!-- END Commercialization -->
    <!-- Use of Funds -->
    <section class="section z-depth-3 m-3 text-dark">
      <div class="text-dark text-center pt-4">
        <div class="display-4">
          Anticipated Use of Funds
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <img
            class="img-fluid"
            src="../assets/business_pics/Yr3FundsUsage.png"
            width="100%"
          >
        </div>
        <div class="col-md-4 centered-on-page">
          <div class="h1 text-center font-weight-bold">
            Year 3<br>% of Cash Flow
          </div>
        </div>
      </div><br>
      <div class="row">
        <div class="col-md-4 centered-on-page">
          <div class="h1 text-center font-weight-bold">
            Year 5<br>% of Revenue
          </div>
        </div>
        <div class="col-md-8">
          <img
            src="../assets/business_pics/Yr5FundsUsage.png"
            width="100%"
          >
        </div>
      </div>
    </section>
    <!-- END Use of Funds -->
    <!-- Investment Opps -->

    <!-- End Investment Opps -->
  </div><!-- End of InvestingPage-->
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
import InvestProgressBar from './InvestProgressBar'

export default {
  mixins: [SecurityCheckMixin],
  name: 'InvestingPage',
  data: function () {
    return {
    }
  },
  computed: {
    numDaysRemaining: function () {
      // Get 1 day in milliseconds
      var oneDay = 1000 * 60 * 60 * 24
      var endDate = new Date('Sep 30, 2020 23:59:59').getTime()
      var today = new Date().getTime()
      var dif = endDate - today
      return Math.round(dif / oneDay, 0)
    }
  },
  components: {
    InvestProgressBar
  },
  methods: {
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    // console.log('Section = ' + this.$route.params.section)
    this.scrollToSection(this.$route.params.section)
    // this.$nextTick(
    //   // Code that will run only after the entire view has been rendered\
    // ) // END Next Tick
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
